<template>
  <v-container fluid>
    <v-row>
      <v-col md="12">
        <v-layout>
          <v-flex md="3" class="mr-4">
            <v-text-field
              clearable
              v-model.trim="search"
              append-icon="search"
              dense
              filled
              placeholder="Search Site Location"
              solo
              flat
              color="cyan"
              :loading="searching"
              v-on:keyup.enter="getProperties()"
            >
            </v-text-field>
          </v-flex>
          <v-flex md="3">
            <v-btn
              depressed
              v-on:click="getProperties()"
              class="mr-4"
              color="cyan white--text"
              >Search</v-btn
            >
            <v-btn
              depressed
              v-on:click="createProperty()"
              color="cyan white--text"
              ><v-icon dark left>mdi-plus</v-icon> Create</v-btn
            >
          </v-flex>
          <v-flex md="3"></v-flex>
          <v-flex md="3"></v-flex>
        </v-layout>
      </v-col>
      <v-col md="12">
        <ListingTable
          class="internal-property-listing-table"
          :columnCount="8"
          :dataLoading="searching"
        >
          <template v-slot:thead>
            <thead>
              <tr>
                <th class="simple-table-th" width="4%">#</th>
                <th class="simple-table-th" width="14%">Site Location #</th>
                <th class="simple-table-th" width="11%">Zone Territory</th>
                <th class="simple-table-th" width="10%">PTW Required</th>
                <th class="simple-table-th" width="17%">Contact Person</th>
                <th class="simple-table-th" width="14%">Contact Person Info</th>
                <th class="simple-table-th" width="21%">Site Location Info</th>
                <th class="simple-table-th" width="9%">Total</th>
              </tr>
            </thead>
          </template>
          <template v-slot:tbody>
            <tbody class="custom-border-bottom">
              <template v-if="properties.length">
                <tr
                  class="alternate-listing-row property-clickable-row"
                  v-for="(row, index) in properties"
                  :key="index"
                  v-on:click="openPropertyDetail(row)"
                >
                  <td class="simple-table-td">{{ index + 1 }}</td>
                  <td class="simple-table-td">
                    <Barcode
                      :barcode="row.barcode"
                      route="property.detail"
                      :id="row.id"
                      v-on:click.native.stop
                    ></Barcode>
                    <br />
                    <v-chip
                      label
                      color="orange"
                      v-if="row.is_same == 1"
                      class="text-white p-3"
                      small
                      >Site Location &amp; Billing</v-chip
                    >
                    <template v-else>
                      <v-chip
                        label
                        color="orange"
                        v-if="row.type == 2"
                        class="text-white p-3"
                        small
                        >Billing</v-chip
                      >
                      <v-chip
                        label
                        outlined
                        color="green"
                        class="text-white p-3"
                        v-if="row.type == 1"
                        small
                        >Site Location</v-chip
                      >
                    </template>
                    <v-chip label color="green" outlined v-if="row.is_tenant"
                      >Tenant</v-chip
                    >
                  </td>
                  <td class="simple-table-td">
                    <v-chip
                      label
                      color="blue"
                      outlined
                      v-if="row.zone_territory"
                      class="text-white p-3"
                      small
                      >{{ row.zone_territory }}
                    </v-chip>
                  </td>
                  <td class="simple-table-td">
                    <v-chip
                      label
                      :color="row.ptw_required ? 'green' : 'grey'"
                      text-color="white"
                      small
                    >
                      {{ row.ptw_required ? "Yes" : "No" }}
                    </v-chip>
                  </td>
                  <td class="simple-table-td" v-if="false">
                    <div class="property-listing-customer">
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Display Name: </b>
                        <!--  {{ row.customer.display_name }} -->
                        <span v-if="row.customer.display_name">{{
                          row.customer.display_name
                        }}</span>
                        <em v-else class="text-muted">no Display Name</em>
                      </p>
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Company: </b>
                        <!-- {{ row.customer.company_name }} -->
                        <span v-if="row.customer.company_name">{{
                          row.customer.company_name
                        }}</span>
                        <em v-else class="text-muted">no Company Name</em>
                      </p>
                      <template v-if="!lodash.isEmpty(row.customer)">
                        <p
                          class="m-0 custom-nowrap-ellipsis"
                          v-if="!lodash.isEmpty(row.customer)"
                        >
                          <b>Email: </b>
                          <span v-if="row.customer.company_email">{{
                            row.customer.company_email
                          }}</span>
                          <em v-else class="text-muted">no email</em>
                          <!--  {{ row.customer.default_person.primary_email }} -->
                        </p>
                        <p
                          class="m-0 custom-nowrap-ellipsis"
                          v-if="!lodash.isEmpty(row.customer)"
                        >
                          <b>Phone: </b>
                          <span v-if="row.customer.company_number">{{
                            row.customer.company_number
                          }}</span>
                          <em v-else class="text-muted">no phone number</em>
                          <!--  {{ row.customer.default_person.primary_phone }} -->
                        </p>
                      </template>
                    </div>
                  </td>
                  <td class="simple-table-td">
                    <div
                      v-if="row.contact_person"
                      class="property-listing-customer property-listing-contact-person"
                    >
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Name: </b>
                        <span v-if="row.contact_person.full_name">{{
                          row.contact_person.full_name
                        }}</span>
                        <em v-else class="text-muted">no name</em>
                      </p>

                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Display Name: </b>
                        <span v-if="row.contact_person.display_name">{{
                          row.contact_person.display_name
                        }}</span>
                        <em v-else class="text-muted">no display name</em>
                        <!--  {{ row.contact_person.display_name }} -->
                      </p>
                    </div>
                  </td>
                  <td class="simple-table-td">
                    <div
                      v-if="row.contact_person"
                      class="property-listing-customer property-listing-contact-info"
                    >
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b><v-icon small>mdi-email</v-icon>: </b>
                        <span v-if="row.contact_person.primary_email">{{
                          row.contact_person.primary_email
                        }}</span>
                        <em v-else class="text-muted">no email</em>
                        <!-- {{ row.contact_person.primary_email }} -->
                      </p>
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b><v-icon small>mdi-phone</v-icon>: </b>
                        <span v-if="row.contact_person.primary_phone">{{
                          row.contact_person.primary_phone
                        }}</span>
                        <em v-else class="text-muted">no phone number</em>
                        <!--   {{ row.contact_person.primary_phone }} -->
                      </p>
                    </div>
                  </td>
                  <td class="simple-table-td">
                    <p class="m-0 custom-nowrap-ellipsis-two-line">
                      <!--  {{ row.property_address }}
                      {{ row.country_name }} -->
                    </p>
                    <div
                      class="property-listing-customer property-listing-site-info"
                      v-if="lodash.isEmpty(row) === false"
                    >
                      <p
                        class="m-0 custom-flex-d property-listing-ellipsis-row"
                      >
                        <b>
                          <v-icon
                            style="font-size: 18px; margin-top: -3px"
                            class="cmt-2"
                          >
                            mdi-home-map-marker
                          </v-icon>
                        </b>
                        <span class="property-listing-ellipsis-text">
                          <template v-if="row && row.property_name">
                            {{ row.property_name }}
                          </template>
                          <em v-else class="text-muted"> no Site Name </em>
                        </span>
                      </p>

                      <p
                        class="m-0 custom-flex-d property-listing-ellipsis-row"
                      >
                        <b>
                          <v-icon
                            style="font-size: 18px; margin-top: -3px"
                            class="cmt-2"
                          >
                            mdi-map-marker
                          </v-icon>
                        </b>
                        <span class="property-listing-ellipsis-text">
                          {{ row.street_1 }}
                          <template v-if="row.street_2">{{
                            row.street_2
                          }}</template>
                          <!-- <br /> -->
                          <template v-if="row.unit_no">{{
                            row.unit_no
                          }}</template>
                          {{ row.country_name }} {{ row.postal_code }}
                        </span>
                      </p>
                    </div>
                  </td>
                  <td class="simple-table-td">
                    <div class="property-listing-customer">
                      <!--  <p class="m-0 custom-nowrap-ellipsis">
                        <b>Quotation: </b>
                        <template v-if="row.quotation_count">
                          <span class="ml-1 count-radius bg-light-success">{{
                            row.quotation_count
                          }}</span>
                        </template>
                        <template v-else
                          ><em class="text--secondary"
                            >no quotation</em
                          ></template
                        >
                      </p> -->
                      <!-- <p class="m-0 custom-nowrap-ellipsis">
                        <b>Invoice: </b>
                        <template v-if="row.invoice_count">
                          <span class="ml-1 count-radius bg-light-success">{{
                            row.invoice_count
                          }}</span>
                        </template>
                        <template v-else
                          ><em class="text--secondary">no invoice</em></template
                        >
                      </p> -->
                      <p class="m-0 custom-nowrap-ellipsis-count">
                        <template v-if="row.visit_count > 0">
                          <v-badge
                            color="red"
                            class="mr-9 ml-2"
                            :content="row.visit_count"
                          >
                          </v-badge>
                        </template>
                        <template v-else>
                          <v-badge color="red" content="0" class="mr-9 ml-2">
                          </v-badge>
                        </template>
                        <b>Visit</b>
                      </p>
                    </div>
                  </td>
                </tr>
              </template>
              <tr v-else-if="!searching">
                <td :colspan="7" class="py-4">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no address at the moment.
                  </p>
                </td>
              </tr>
            </tbody>
          </template>
        </ListingTable>
        <div class="listing-footer-fixed">
          <ListingFooter
            :dataLoading="searching"
            :showingFrom="showingFrom"
            :showingTo="showingTo"
            :totalRows="totalRows"
            :currentPage="currentPage"
            :totalPages="totalPages"
            removePage
          ></ListingFooter>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
export default {
  data() {
    return {
      search: null,
      searching: true,
      properties: [],
      dataLoading: false,
      totalRows: 0,
      currentPage: 1,
      totalPages: 0,
      rowsOffset: 0,
    };
  },
  components: {
    Barcode,
    ListingTable,
    ListingFooter,
  },
  props: {
    customer: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    customer() {
      this.getProperties();
    },
  },
  methods: {
    openPropertyDetail(row) {
      this.$router.push(
        this.getDefaultRoute("property.detail", {
          params: { id: this.lodash.toSafeInteger(row.id) },
        })
      );
    },
    createProperty() {
      this.$router.push(
        this.getDefaultRoute("property.create", {
          query: { customer: this.customer },
        })
      );
    },
    getProperties() {
      if (this.customer) {
        this.searching = true;
        this.$store
          .dispatch(QUERY, {
            url: `property/customer/${this.customer}`,
            data: {
              search: this.search,
              status: "all",
              current_page: this.currentPage,
              per_page: 20,
            },
          })
          .then(({ data }) => {
            this.totalPages = Math.max(
              1,
              data.total_pages || Math.ceil(data.total_rows / data.per_page)
            );
            this.properties = data.rows || [];
            this.totalRows = data.total_rows || 0;
            this.currentPage = data.current_page || 1;
            this.perPage = data.per_page || 20;
            this.rowsOffset = data.offset || 0;
            console.log(this.totalRows);
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.searching = false;
          });
      }
    },
  },
  computed: {
    showingFrom() {
      return this.properties.length ? this.rowsOffset + 1 : 0;
    },

    showingTo() {
      return this.rowsOffset + this.properties.length;
    },
  },
  mounted() {
    PaginationEventBus.$on("update:pagination", (param) => {
      this.currentPage = param;
      this.getProperties();
    });
    this.getProperties();
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
};
</script>

<style scoped>
.internal-property-listing-table ::v-deep .v-data-table__wrapper {
  height: calc(100vh - 300px) !important;
}

.internal-property-listing-table ::v-deep table {
  width: 100%;
  table-layout: fixed;
}

.property-clickable-row {
  cursor: pointer;
}

.property-listing-contact-person {
  max-width: 250px;
}

.property-listing-contact-info {
  max-width: 220px;
}

.property-listing-site-info {
  max-width: 300px;
}

.property-listing-ellipsis-row {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
}

.property-listing-ellipsis-row > b {
  flex: none;
}

.property-listing-ellipsis-text {
  display: block;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .listing-footer-fixed {
  position: fixed;
  bottom: 0;
  left: 498px;
  right: 0;
  background: #fff;
  z-index: 100;
} */
</style>
